export const statusColors = (actionRequired) => actionRequired ? { background: '#E84961', foreground: 'white', border: 'transparent' } : { background: 'white', foreground: 'black', border: 'black' };

const colors = {
  lightGrey: '#033269',
  lighterGrey: '#0332693D',
  acceptRGB: '56, 140, 255',
};

export default colors;